import { RoomSettingConstants } from '@colonist/game-base-types';
import { socket } from '../EntryShared.ts';
import { UIRoomCenterSettingsMaxPlayersView } from './UIRoomCenterSettingsMaxPlayersView.ts';
import { GameModeDataController } from '@colonist/shared-types';
import { setElementOnClick } from '../ui_utils/DomUtils.ts';
import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
export class UIRoomCenterSettingsMaxPlayersController {
    update(newRoomState) {
        var _GameModeDataController_getModeDataForMode;
        this.currentMaxPlayerCount = newRoomState.gameSetting.maxPlayers;
        var _GameModeDataController_getModeDataForMode_defaultPlayerCount;
        const defaultPlayerCount = (_GameModeDataController_getModeDataForMode_defaultPlayerCount = (_GameModeDataController_getModeDataForMode = GameModeDataController.getModeDataForMode(newRoomState.gameSetting.modeSetting)) === null || _GameModeDataController_getModeDataForMode === void 0 ? void 0 : _GameModeDataController_getModeDataForMode.defaultPlayerCount) !== null && _GameModeDataController_getModeDataForMode_defaultPlayerCount !== void 0 ? _GameModeDataController_getModeDataForMode_defaultPlayerCount : RoomSettingConstants.DEFAULT_PLAYER_COUNT;
        const gameModeMaxPlayerCount = UIRoomCenterSettingsMaxPlayersController.getEffectiveMaxPlayerCount(newRoomState);
        this.view.setMaxPlayerCount(this.currentMaxPlayerCount, gameModeMaxPlayerCount);
        this.view.container.classList.toggle('selected', this.currentMaxPlayerCount != defaultPlayerCount);
    }
    load(roomState) {
        this.initSpeedSettings(roomState);
    }
    initSpeedSettings(roomState) {
        const { maxPlayersDivBody: footerDiv, maxPlayersRightArrow: rightArrow, maxPlayersLeftArrow: leftArrow } = this.view;
        this.gameModeMaxPlayerCount = UIRoomCenterSettingsMaxPlayersController.getEffectiveMaxPlayerCount(roomState);
        this.view.setMaxPlayerCount(this.currentMaxPlayerCount, this.gameModeMaxPlayerCount);
        const isMinPossiblePlayers = this.currentMaxPlayerCount == this.minPlayerCount;
        const isMaxPossiblePlayers = this.currentMaxPlayerCount == this.gameModeMaxPlayerCount;
        leftArrow.classList.toggle('disabled', isMinPossiblePlayers);
        rightArrow.classList.toggle('disabled', isMaxPossiblePlayers);
        if (UIRoomCenterSettingsMaxPlayersController.isGuest(roomState)) {
            footerDiv.className = 'option_body guest';
            rightArrow.classList.toggle('hidden', true);
            leftArrow.classList.toggle('hidden', true);
            setElementOnClick(rightArrow, ()=>undefined);
            setElementOnClick(leftArrow, ()=>undefined);
            return;
        }
        footerDiv.className = 'option_body';
        rightArrow.classList.toggle('hidden', false);
        leftArrow.classList.toggle('hidden', false);
        setElementOnClick(rightArrow, ()=>{
            if (this.currentMaxPlayerCount >= this.gameModeMaxPlayerCount) return;
            socket.roomClient.setMaxPlayers(this.currentMaxPlayerCount + 1);
        });
        setElementOnClick(leftArrow, ()=>{
            if (this.currentMaxPlayerCount <= this.minPlayerCount) return;
            socket.roomClient.setMaxPlayers(this.currentMaxPlayerCount - 1);
        });
    }
    updateInteractabilityOfElements(roomState) {
        this.load(roomState);
    }
    static getEffectiveMaxPlayerCount(roomState) {
        if (UIUtilsEjsVariables.shouldHideStoreOnMobile) return RoomSettingConstants.DEFAULT_PLAYER_COUNT;
        const gameModeMax = GameModeDataController.getMaxAllowablePlayerCountForMode(roomState.gameSetting.modeSetting);
        return gameModeMax;
    }
    static isGuest(roomState) {
        return socket.controller.session.id != roomState.hostSession.userSessionId;
    }
    constructor(container){
        this.minPlayerCount = RoomSettingConstants.MIN_PLAYER_COUNT;
        this.gameModeMaxPlayerCount = RoomSettingConstants.MAX_PLAYER_COUNT;
        this.currentMaxPlayerCount = RoomSettingConstants.DEFAULT_PLAYER_COUNT;
        this.view = new UIRoomCenterSettingsMaxPlayersView(container);
    }
}
